const Spinner = () => (
    <div className="flex justify-center items-center h-full">
      <div className="animate-spin rounded-full h-24 w-24 border-t-4 border-blue-500"></div>
    </div>
  );
  
  export default Spinner;
  